import React, { useState, useEffect } from "react";
import Base from "../admin_components/Admin_Base";
import {
  Breadcrumbs,
  Link,
  TextField,
  Button,
  Select,
  MenuItem,
  Tooltip,
  InputLabel,
  FormControl,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import authAxios from "../Auth/useAxios";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveSharpIcon from "@mui/icons-material/SaveSharp";
import CancelIcon from "@mui/icons-material/Cancel";
import { Modal } from "react-bootstrap";
import "../CustomerProperty/CustomerProperty.css";
import { Switch } from "@mui/material";
import { useRef } from "react";
// import { Button } from "@mui/material";
import { IconButton } from "@mui/material";
import { SaveSharp, Cancel, Edit, Delete } from "@mui/icons-material";
import { ClipLoader } from "react-spinners";

const CustomerPropertyList = () => {
  const [recordsPerPage, setRecordsPerPage] = useState(5);
  const [customerProperties, setCustomerProperties] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editedProperty, setEditedProperty] = useState({});
  const [customers, setCustomers] = useState([]);
  const [plots, setPlots] = useState([]);
  const [showEmi, setShowEmi] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedEmiMonths, setSelectedEmiMonths] = useState();
  const [emiStartDate, setEmiStartDate] = useState("2025-01-24");
  const [nextEmiDate, setNextEmiDate] = useState("2025-02-24");
  const [editEmiMonths, setEditEmiMonths] = useState(selectedEmiMonths);
  const [editNextEmiDate, setEditNextEmiDate] = useState(nextEmiDate);
  const [editCount, setEditCount] = useState(0);
  const [hasEdited, setHasEdited] = useState(false);
  const [filterCustomer, setFilterCustomer] = useState("");
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [emiEditHistory, setEmiEditHistory] = useState([]);
  const [selectedCustomerProperty, setSelectedCustomerProperty] =
    useState(null);
  const [editRemainingEmiMonths, setEditRemainingEmiMonths] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [incentiveList, setIncentiveList] = useState([]);
  const [selectedIncentive, setSelectedIncentive] = useState("");
  // const [editRemainingEmiMonths, setEditRemainingEmiMonths] = useState(0);
  // const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;


  const [status, setStatus] = useState("");
  const editEmiInputRef = useRef(null);

  const maxRemainingEmi =
    selectedCustomerProperty?.selectedEmiMonths -
    selectedCustomerProperty?.emiPaid || 0;

  useEffect(() => {
    fetchCustomerPropertyList();
    fetchCustomers();
    fetchPlots();
  }, []);

  useEffect(() => {
    if (showEditModal && editEmiInputRef.current) {
      editEmiInputRef.current.focus();
    }
  }, [showEditModal]);
  const fetchCustomerPropertyList = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/get-all-customer-properties?customerPropertyEnum=ACTIVE`
      );

      const activeProperties = response.data.filter(
        (property) => property.customerPropertyEnum === "ACTIVE"
      );
      setCustomerProperties(activeProperties);
      console.log("customer properties", activeProperties);
    } catch (error) {
      console.error("Error fetching customer properties:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchIncentives = async () => {
      try {
        const response = await authAxios.get(
          `${ADMIN_API_BASE_URL}/main/admin/get-all-incentives`
        );
        setIncentiveList(response.data);
      } catch (error) {
        console.error("Error fetching incentives:", error);
      }
    };

    fetchIncentives();
  }, []);

  const handleChange = (event) => {
    setSelectedIncentive(event.target.value);
  };

  const fetchCustomers = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/list-customers`
      );
      setCustomers(response.data);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const handleToggle = () => {
    if (status === "Active") {
      Swal.fire({
        title: "Are you sure?",
        text: "You are changing the status to Inactive!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.isConfirmed) {
          setStatus("Inactive");
          Swal.fire(
            "Updated!",
            "Status has been changed to Inactive.",
            "success"
          );
        }
      });
    } else if (status === "Inactive") {
      Swal.fire({
        title: "Are you sure?",
        text: "You are changing the status to Active!",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.isConfirmed) {
          setStatus("Active");
          Swal.fire(
            "Updated!",
            "Status has been changed to Active.",
            "success"
          );
        }
      });
    }
  };

  const fetchPlots = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/get-all-plots`
      );
      setPlots(response.data);
    } catch (error) {
      console.error("Error fetching plots:", error);
    }
  };

  // Enable Edit Mode for a Row
  const handleEdit = (index) => {
    setEditIndex(index);
    setEditedProperty({ ...customerProperties[index] });
  };

  // Handle Input Changes
  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setEditedProperty((prev) => {
      const updatedProperty = { ...prev };

      // Handle nested fields
      if (field.includes(".")) {
        const keys = field.split(".");
        updatedProperty[keys[0]] = {
          ...updatedProperty[keys[0]],
          [keys[1]]: value,
        };
      } else {
        updatedProperty[field] = value;
      }

      return updatedProperty;
    });
  };

  const handleSave = () => {
    const maxRemainingEmi =
      selectedCustomerProperty.selectedEmiMonths -
      selectedCustomerProperty.emiPaid;

    if (
      editRemainingEmiMonths > maxRemainingEmi ||
      editRemainingEmiMonths <= 0
    ) {
      alert(
        `Invalid EMI months! Please enter a value between 1 and ${maxRemainingEmi}`
      );
      return;
    }

    const newHistoryEntry = {
      timestamp: new Date().toISOString(),
      updatedEmiMonths: editRemainingEmiMonths,
      nextEmiDate: editNextEmiDate,
    };

    setEmiEditHistory((prevHistory) => [newHistoryEntry, ...prevHistory]);

    setSelectedEmiMonths(editRemainingEmiMonths);
    setNextEmiDate(editNextEmiDate);
    setShowEditModal(false);
  };

  const handleCancel = () => {
    setEditIndex(null);
    setEditedProperty({});
    setEditEmiMonths(selectedEmiMonths);
    setEditNextEmiDate(nextEmiDate);
    setShowEditModal(false);
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await authAxios.delete(
            `${ADMIN_API_BASE_URL}/main/admin/delete-customer-property/${id}`
          );
          setCustomerProperties(
            customerProperties.filter((prop) => prop.id !== id)
          );
          Swal.fire("Deleted!", "The property has been deleted.", "success");
        } catch (error) {
          console.error("Error deleting property:", error);
          Swal.fire("Error!", "Could not delete the property.", "error");
        }
      }
    });
  };

  const handleViewClick = () => {
    setShowEmi(true);
  };

  const handleRemainingEmiChange = (e) => {
    const value = Number(e.target.value);

    if (value > maxRemainingEmi) {
      setErrorMessage(`Remaining EMI months cannot exceed ${maxRemainingEmi}`);
    } else {
      setErrorMessage(""); // Clear error if valid
    }

    setEditRemainingEmiMonths(value);
    const maxLimit =
      selectedCustomerProperty.selectedEmiMonths -
      selectedCustomerProperty.emiPaid;

    if (value > maxLimit) {
      setErrorMessage(`Remaining EMI months cannot exceed ${maxLimit}`);
    } else if (value <= 0) {
      setErrorMessage("Remaining EMI months must be greater than 0");
    } else {
      setErrorMessage(""); // Clear error if valid
    }

    setEditRemainingEmiMonths(value);
  };

  const handleViewEmi = (property) => {
    setSelectedCustomerProperty(property);
    setSelectedEmiMonths(property.selectedEmiMonths);
    setEmiStartDate(property.emiStartDate?.split("T")[0]);
    setNextEmiDate(property.emiList?.[0]?.emiDate);
    setShowEmi(true);
  };

  const handleEditClick = () => {
    setShowEditModal(true);
  };

  // const handleCancel = () => {
  //   setEditEmiMonths(selectedEmiMonths);
  //   setEditNextEmiDate(nextEmiDate);
  //   setShowEditModal(false);
  // };

  useEffect(() => {
    if (filterCustomer) {
      setFilteredProperties(
        customerProperties.filter((property) =>
          property.customer.customerName
            .toLowerCase()
            .includes(filterCustomer.toLowerCase())
        )
      );
    } else {
      setFilteredProperties(customerProperties);
    }
  }, [filterCustomer, customerProperties]);


  const totalPages = Math.ceil(filterCustomer.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRequests = filterCustomer.slice(startIndex, endIndex);


  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div
            className="pt-3 mt-5 res_container"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Link underline="hover" color="inherit" href="/admin/dashboard">
                Dashboard
              </Link>
              <Link
                underline="none"
                color="inherit"
                href="/admin/customer_property_list"
              >
                Customer Property List
              </Link>
            </Breadcrumbs>
          </div>

          <h2 className="text-center fw-bold main_heading">
            Customer Property List
          </h2>
          <hr style={{ width: "95%", margin: "auto" }} />

          <div className="container">
            <div
              className="table-header m-3"
              style={{
                display: "flex",
                justifyContent: "end",
                width: "96%",
                margin: "auto",
              }}
            >
              <TextField
                label="Filter by Customer Name"
                variant="outlined"
                size="small"
                style={{ width: "250px" }}
                value={filterCustomer}
                onChange={(e) => setFilterCustomer(e.target.value)}
              />
            </div>

            <Table className="customer-table">
              <Thead
                className="text-white"
                style={{ backgroundColor: "darkslategrey" }}
              >
                <Tr>
                  <Th>S.No</Th>
                  <Th>Customer Name</Th>
                  <Th>Group Name</Th>
                  <Th>Mobile Number</Th>
                  <Th>Passbook No</Th>
                  <Th>Plot Purchased</Th>
                  <Th>Plot Direction</Th>
                  <Th>Date of Plot Purchased</Th>
                  <Th>Status</Th>
                  <Th>EMI Details</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {filteredProperties.map((property, index) => (
                  <Tr key={property.id}>
                    <Td>{index + 1}</Td>
                    <Td>
                      {editIndex === index ? (
                        <Select
                          value={editedProperty.customer?.customerName || ""}
                          onChange={(e) =>
                            handleInputChange(e, "customer.customerName")
                          }
                        >
                          {customers.map((cust) => (
                            <MenuItem key={cust.id} value={cust.customerName}>
                              {cust.customerName}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : (
                        property.customer.customerName
                      )}
                    </Td>
                    <Td>
                      {editIndex === index ? (
                        <Select
                          value={editedProperty.customer?.groupName || ""}
                          onChange={(e) =>
                            handleInputChange(e, "customer.groupName")
                          }
                        >
                          {customers.map((cust) => (
                            <MenuItem key={cust.id} value={cust.groupName}>
                              {cust.groupName}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : (
                        property.customer.groupName
                      )}
                    </Td>
                    <Td>
                      {editIndex === index ? (
                        <TextField
                          value={editedProperty.customer?.mobileNumber || ""}
                          onChange={(e) =>
                            handleInputChange(e, "customer.mobileNumber")
                          }
                        />
                      ) : (
                        property.customer.mobileNumber
                      )}
                    </Td>
                    <Td>
                      {editIndex === index ? (
                        <TextField
                          value={editedProperty.customer?.passbook || ""}
                          onChange={(e) => handleInputChange(e, "passbook")}
                        />
                      ) : (
                        property.customer.passbook
                      )}
                    </Td>
                    {/* <Td>
                  {editIndex === index ? (
                    <Select
                      value={editedProperty.plots?.plotNumber || ""}
                      onChange={(e) => handleInputChange(e, "plots.plotNumber")}
                    >
                      {plots.map((plot) => (
                        <MenuItem key={plot.id} value={plot.plotNumber}>
                          {plot.plotNumber}
                        </MenuItem>
                      ))}
                    </Select>
                  ) : (
                    property.plots.plotNumber
                  )}
                </Td> */}
                    <Td>{property.plots.plotNumber}</Td>
                    <Td>{property.plots.plotDirection}</Td>
                    <Td>{property.purchaseDate?.split("T")[0]}</Td>
                    <Td>
                      <Switch
                        checked={status === property.plots.active}
                        onChange={handleToggle}
                      />
                    </Td>
                    <Td>
                      <Button
                        className="view-button"
                        onClick={() => handleViewEmi(property)}
                      >
                        EMI
                      </Button>
                    </Td>
                    <Td>
                      {editIndex === index ? (
                        <div style={{ display: "flex", gap: "5px" }}>
                          <Tooltip title="Save">
                            <IconButton
                              onClick={handleSave}
                              sx={{ color: "green" }}
                            >
                              <SaveSharp />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Cancel">
                            <IconButton
                              onClick={handleCancel}
                              sx={{ color: "red" }}
                            >
                              <Cancel />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ) : (
                        <div style={{ display: "flex", gap: "5px" }}>
                          <Tooltip title="Edit">
                            <IconButton
                              onClick={() => handleEdit(index)}
                              sx={{ color: "blue" }}
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Delete">
                            <IconButton
                              onClick={() => handleDelete(property.id)}
                              sx={{ color: "red" }}
                            >
                              <Delete />
                            </IconButton>
                          </Tooltip>
                        </div>
                      )}
                    </Td>
                    ; ;
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </div>

          {/* <div className="cust_prop_list_cont">
        <div className="display_groups">
          <TextField
            label="Filter by Customer Name"
            variant="outlined"
            size="small"
            style={{ width: "250px" }}
            value={filterCustomer}
            onChange={(e) => setFilterCustomer(e.target.value)}
          />

          <TextField
            type="number"
            label="Records per page"
            variant="outlined"
            size="small"
            style={{ width: "150px", marginBottom: "10px" }}
            value={recordsPerPage}
            onChange={(e) => setRecordsPerPage(Number(e.target.value))}
          />
        </div>
      </div> */}

          <Modal
            show={showEmi}
            onHide={() => setShowEmi(false)}
            className="fullscreen-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Customer EMI Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="modal-container">
                <div className="emi-details">
                  <h3 className="text-center"> EMI Details</h3>
                  {selectedCustomerProperty ? (
                    <Table className="emidetail-table">
                      <Tbody>
                        <Tr>
                          <Td>Cost Of the Plot</Td>
                          <Td>
                            ₹{selectedCustomerProperty.plots?.plotAmount || "N/A"}
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>Amount Paid Till Now</Td>
                          <Td>₹{Math.round(selectedCustomerProperty.amountPaid) || "N/A"}</Td>
                        </Tr>
                        <Tr>
                          <Td>Total EMI's Paid</Td>
                          <Td>{selectedCustomerProperty.emiPaid || "N/A"}</Td>
                        </Tr>
                        <Tr>
                          <Td>Remaining Amount</Td>
                          <Td>
                            ₹{Math.round(selectedCustomerProperty.remainingAmount) || "N/A"}
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>Selected EMI Months</Td>
                          <Td>
                            {selectedCustomerProperty.selectedEmiMonths || "N/A"}
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>Remaining EMI's</Td>
                          <Td>
                            {selectedCustomerProperty.selectedEmiMonths -
                              selectedCustomerProperty.emiPaid}
                          </Td>
                        </Tr>

                        {selectedCustomerProperty?.emiStartDate && (
                          <Tr>
                            <Td>EMI Start Date</Td>
                            <Td>
                              {selectedCustomerProperty.emiStartDate.split("T")[0]}
                            </Td>
                          </Tr>
                        )}

                        {selectedCustomerProperty?.emiEndDate && (
                          <Tr>
                            <Td>EMI End Date</Td>
                            <Td>
                              {selectedCustomerProperty.emiEndDate.split("T")[0]}
                            </Td>
                          </Tr>
                        )}

                        <Tr>
                          <Td>EMI Amount monthly</Td>
                          <Td>{Math.round(selectedCustomerProperty.emiAmount)}</Td>
                        </Tr>
                        <Tr>
                          <Td>Employee Incentive</Td>
                          <Td>{selectedCustomerProperty.employeeIncentives.name}</Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  ) : (
                    <p>Loading EMI details...</p>
                  )}
                  <Button
                    className="edit-button"
                    // onClick={() => setShowEditModal(true)}
                    onClick={handleEditClick}
                  >
                    Edit EMI Details
                  </Button>
                </div>

                {showEditModal && (
                  <div className="edit-emi-details">
                    <h3 className="text-center">Edit EMI Details</h3>
                    <hr />
                    <label>Remaining EMI's</label>
                    <select
                      ref={editEmiInputRef}
                      value={editRemainingEmiMonths}
                      onChange={handleRemainingEmiChange}
                      className="modal-input"
                    >
                      <option value="">Select EMI Months</option>
                      {Array.from({ length: maxRemainingEmi }, (_, i) => i + 1).map(
                        (num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        )
                      )}
                    </select>

                    {errorMessage && (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        {errorMessage}
                      </p>
                    )}

                    <div className="input-group">
                      <label>Next EMI Date</label>
                      <input
                        type="date"
                        value={editNextEmiDate}
                        onChange={(e) => setEditNextEmiDate(e.target.value)}
                        className="modal-input"
                      />
                    </div>
                    <div className="modal-actions">
                      <button className="save-button" onClick={handleSave}>
                        Save
                      </button>
                      <button
                        className="cancel-button"
                        onClick={() => setShowEditModal(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}

                {emiEditHistory.length > 0 && (
                  <div className="emi-history">
                    <h3 className="text-center">EMI Edit History</h3>
                    <Table className="history-table">
                      <Thead>
                        <Tr>
                          <Th>Timestamp</Th>
                          <Th>Updated EMI Months</Th>
                          <Th>Next EMI Date</Th>
                          <Th>EMI Amount</Th>
                          <Th>EMI End Date</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {emiEditHistory.map((entry, index) => {
                          const remainingEmiMonths = entry?.updatedEmiMonths || 1;

                          const emiPerMonth =
                            selectedCustomerProperty?.remainingAmount
                              ? (
                                selectedCustomerProperty.remainingAmount /
                                remainingEmiMonths
                              ).toFixed(2)
                              : "N/A";

                          let emiEndDate = "N/A";
                          if (entry?.nextEmiDate) {
                            const nextEmi = new Date(entry.nextEmiDate);
                            nextEmi.setMonth(
                              nextEmi.getMonth() + (remainingEmiMonths - 1)
                            );
                            emiEndDate = nextEmi.toISOString().split("T")[0];
                          }

                          return (
                            <Tr key={index}>
                              <Td>{new Date(entry?.timestamp).toLocaleString()}</Td>
                              <Td>{remainingEmiMonths}</Td>
                              <Td>{entry?.nextEmiDate || "N/A"}</Td>
                              <Td>₹{emiPerMonth}</Td>
                              <Td>{emiEndDate}</Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>
                )}
              </div>
            </Modal.Body>
          </Modal>

          <div className="pagination-controls-payment-history">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="mx-2">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </Base>
  );
};

export default CustomerPropertyList;
